"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'みどりのチケット公式',
    organizationId: 'gCj5gdkP7RCPnJACj6h9',
    applicationKey: 'greenticket',
    applicationType: 'organization',
    artistId: undefined,
    version: '1.0.0',
    deeplinkUrl: 'https://green-ticket.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/3562308',
    deeplinkProd: 'green-ticket.utoniq.com',
    custom: {
        modules: {
            item: true,
            store: true,
            resale: true,
            preSale: true,
            event: true,
            cart: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
        ],
        globalTabs: ['home', 'events', 'notifications', 'myProfile'],
        artistTabs: ['home', 'store', 'posts'],
    },
});
